import { ERROR_MESSAGES } from "../constants/smartRoomConstants";

export const getSmartRoomApiErrorMessage = (
  err,
  fallback = ERROR_MESSAGES.GENERIC
) => {
  if (!err) return fallback;

  const code = err.code || "";
  const message = String(err.message || "").toLowerCase();
  const status = err.response?.status;

  if (
    code === "ECONNABORTED" ||
    message.includes("timeout") ||
    status === 408
  ) {
    return ERROR_MESSAGES.TIMEOUT;
  }

  if (
    code === "ERR_NETWORK" ||
    message.includes("network error") ||
    message.includes("failed to fetch") ||
    message.includes("cors")
  ) {
    return fallback === ERROR_MESSAGES.WEATHER_FAILED
      ? ERROR_MESSAGES.WEATHER_NETWORK
      : ERROR_MESSAGES.GENERIC;
  }

  if (status === 404) {
    if (fallback === ERROR_MESSAGES.DEVICE_STATUS_FAILED) {
      return ERROR_MESSAGES.DEVICE_NOT_FOUND;
    }
    if (fallback === ERROR_MESSAGES.WEATHER_FAILED) {
      return ERROR_MESSAGES.WEATHER_FAILED;
    }
    if (
      fallback === ERROR_MESSAGES.SPACES_LOAD_FAILED ||
      fallback === ERROR_MESSAGES.HOME_NOT_FOUND
    ) {
      return ERROR_MESSAGES.HOME_NOT_FOUND;
    }
    return fallback;
  }

  if (status >= 500) {
    return fallback;
  }

  return (
    err.response?.data?.message ||
    err.response?.data?.error ||
    (typeof err.response?.data === "string" ? err.response.data : null) ||
    fallback
  );
};
